export const openId = "wxa9234778628674c3";
export const statusType = ["", "登记 ", "装车", "装车完成", "结算"];
export const telPattern = /^[1][3,4,5,7,8,9][0-9]{9}$/;
export const truckPattern = /[京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼川贵云渝藏陕甘青宁新使]{1}[a-zA-Z]{1}[0-9a-zA-Z]{5,6}[挂学警港澳使领]{0,1}$/;
